import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=0d4a9848&scoped=true&"
import script from "./MessageCenter.vue?vue&type=script&lang=js&"
export * from "./MessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=0d4a9848&scoped=true&lang=scss&"
import style1 from "./MessageCenter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a9848",
  null
  
)

export default component.exports